module.exports = __webpack_public_path__ + "static/media/5DPO24.d819b294.jpg";